<template>
  <div class="export-modal">
    <Modal
      v-model="exportModal"
      :footer-hide="true"
      :closable="false"
      title="学校考勤确认单导入"
      :width="600"
    >
      <div>
        <div class="alertText">
          <div class="alertText_title">导入提示</div>
          <div class="alertText_item">
            1、点击【下载导入模板】进行导入文件模拟的下载。
          </div>
          <div class="alertText_item">
            2、以系统导入模板为准，请勿自行创建导入模板。
          </div>
          <div class="alertText_item">
            3、教师姓名为学校单位中真实存在的用户，请确保教师姓名真实存在。
          </div>
          <div class="alertText_item">
            4、教师手机号码+教师姓名为校验条件，请确保关联正确。
          </div>
        </div>

        <ul class="batch-list">
          <li class="batch-list-item">
            <p class="label">导入月份</p>
            <div class="right">{{ month }}</div>
          </li>
          <li class="batch-list-item">
            <p class="label">下载导入模版：</p>
            <div class="right">
              <span class="loadfont" @click="donwExcel"
                >点击下载学校考勤确认单导入模板</span
              >
            </div>
          </li>
          <li class="batch-list-item">
            <p class="label">上传导入文件</p>
            <div class="right">
              <div
                style="display: flex; flex-direction: row; align-items: center"
              >
                <Button
                  type="primary"
                  @click="handleUploadInStepOne"
                  style="margin-right: 10px"
                  >上传导入文件</Button
                >
                <div
                  v-show="file"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  {{ file && file.name
                  }}<img
                    class="success-icon"
                    src="../image/icon_success@2x.png"
                    v-if="successNum !== null"
                  />
                </div>
              </div>
              <div
                style="margin-top: 16px"
                class="item"
                v-if="successNum !== null || failNum !== null"
              >
                <Button
                  v-if="failNum && failNum > 0"
                  @click="handleErrorDownload"
                  >下载错误数据</Button
                >
                <p>
                  上传成功<span style="color: #00ad67">{{ successNum }}</span>
                  <span>条数据，</span>上传失败<span style="color: #ff3f3f">{{
                    failNum
                  }}</span
                  >条数据
                </p>
              </div>
            </div>
            <div class="input-box">
              <input
                id="input-block"
                ref="uploadInput"
                type="file"
                class="input-block"
                accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                @change="handleUpload"
              />
            </div>
          </li>
        </ul>
        <div class="modal-430-bottom">
          <Button @click="handleExCancle">取消</Button>
          <Button type="primary" @click="handleExSubmit">确定</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
  
<script>
import orderApi from '@/request/orderCenter/index.js';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import axios from 'axios';
export default {
  data() {
    return {
      successNum: null,
      failNum: null,
      file: null,
      fileId: '',
      exportModal: false, //教师考勤导出
    }
  },
  props: {
    sheetId: {
      type: String,
      default: ''
    },
    month: {
      type: String,
      default: ''
    },
    schoolName: {
      type: String,
      default: ''
    }

  },
  methods: {
    donwExcel() {
      axios.get('./schoolAttendExcel.xlsx', {
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        let fname = `${this.schoolName}-${this.month}学校考勤确认单导入模板.xlsx`;
        link.href = url;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.log("error", error)
        console.log('error:' + JSON.stringify(error))
      });
    },
    // 上传文件
    async uploadExcel() {
      try {
        const formData = new FormData();
        let res;
        formData.append('file', this.file);
        formData.append('sheetId', this.sheetId);
        this.$Spin.show();
        res = await orderApi.importSettlementSheetSchItem(formData);
        this.$Spin.hide();
        if (res.status == 200 && !res.error) {
          let { successNum, failNum, errorFileId } = res.data.message
          this.successNum = Number(successNum)
          this.failNum = Number(failNum)
          this.fileId = errorFileId;
          this.$emit('on-submit', { successNum: this.successNum, failNum: this.failNum })
        } else if (res.status == 200 && res.error) {
          this.$Message.error({
            content: res.error,
          });
        }
        console.log(res);
      } catch (err) {
        console.log(err)
        this.$Spin.hide();
        this.$Message.error({
          content: '请重新上传文件',
          duration: 2
        });
      }
    },
    handleUploadInStepOne() {
      const inputElement = document.getElementById('input-block');
      inputElement.click(); // 点击下载
    },
    handleShow() {
      this.successNum = null;
      this.failNum = null;
      this.file = null;
      this.fileId = '';
      this.exportModal = true
    },
    handleHide() {
      this.exportModal = false
    },
    handleExCancle() {
      this.handleHide()
    },
    handleExSubmit() {
      // this.$emit('on-submit', this.tabIndex)
      if (!this.file) {
        this.$Message.error({
          content: '请选择文件',
        })
        return;
      }
      this.uploadExcel()
    },
    handleUpload(ev) {
      this.initFileInfo()
      this.file = ev.target.files[0];
      ev.target.value = '';// 解决多次选择同一个文件无效果的问题
    },
    initFileInfo() {
      this.file = null;
      this.successNum = null;
      this.failNum = null;
    },
    // 下载token
    async getDownloadtoken(fileId) {
      return new Promise(async (resolve, reject) => {
        const params = {
          fileId: [fileId],
          type: 2
        };
        const res = await cateringAdmin.getDownloadtoken(params);
        if (res.status === 200) {
          this.downloadUrl = res.message.downUrl;
          this.downloadToken = res.message.token;
        }
        resolve()
      })

    },
    async handleErrorDownload() {
      await this.getDownloadtoken(this.fileId);
      const href = `${this.downloadUrl}?fileId=${this.fileId}&token=${this.downloadToken}`;
      const downloadElement = document.createElement('a');
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.download = name; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
    },
  }
}
</script>
  
<style  lang="scss" scoped>
.loadfont {
  cursor: pointer;
  font: 14px;
  color: #488ffa;
}
.alertText {
  padding: 10px;
  border-radius: 10px;
  background: #fff8ea;
  border: 1px solid #ffc68b;
  margin-bottom: 10px;
  border-radius: 4px;
  color: #f3a000;

  .alertText_title {
    padding-bottom: 5px;
    font-weight: bolder;
  }

  .alertText_item {
    padding: 2px 0;
  }
}

.batch-list {
  padding: 20px 0;

  &-item {
    display: flex;
    margin-bottom: 16px;
    align-items: center;

    .label {
      font-size: 14px;
      margin-right: 16px;
      color: rgba(0, 0, 0, 0.45);
      width: 120px;
    }

    .stencil-xlsx {
      display: flex;
      align-items: center;
      margin-left: 16px;
      color: #488ffa;
      cursor: pointer;
    }

    .input-box {
      text-align: center;

      .input-block {
        width: 1px;
        height: 1px;
        visibility: hidden;
        overflow: hidden;
        margin: 0 auto;
      }
    }

    .right {
      flex: 1;
      align-items: center;

      .item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        p {
          background: #f3f5f8;
          line-height: 32px;
          padding: 0 8px;
          height: 32px;
          flex: 1;

          .success-icon {
            width: 14px;
            height: 14px;
            margin-left: 8px;
            position: relative;
            top: 1px;
          }
        }
      }
    }
  }
}
</style>